import { PersonPinSharp } from "@mui/icons-material";
import styled from "styled-components";


export const ListContainer = styled.div<{isMobile?: boolean}>`
    background-color: white;
    height: 200px;
    overflow-y: auto;
    margin-bottom: 20px;

    ::-webkit-scrollbar {
        width: 5px;
    }

    ::-webkit-scrollbar-track {
        box-shadow: inset 0 0 5px #E0F0F5; 
        border-radius: 8px;
    }
    
    ::-webkit-scrollbar-thumb {
        background: #556ED1; 
        border-radius: 5px;
    }

`